// react
import { useContext } from "react";
import { useTranslation } from "react-i18next";
// node-modules
// mui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useTheme,
  styled,
} from "@mui/material";
// src
import HelmContext from "../Contexts/HelmContext";
import { ECoordinateTransformMode } from "../../config/componentsConfig";

type Props = {
  open: boolean;
  close: () => void;
  // exec: () => void;
};

const DeleteAllPointsDialog = (props: Props) => {
  const { t } = useTranslation();
  // const [openDialog, setOpenDialog] = useState(false);
  // const [existingProjectName, setExistingProjectName] = useState(props.projectName);
  const { currentHelmTab, handleDelete } = useContext(HelmContext);
  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customModalColor = {
    color: theme.palette.base.modal,
  };

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  const CustomCanselButton = styled(Button)({
    background: theme.palette.base.modal,
    color: theme.palette.base.contrast,
    boxShadow: "none",
    "&:hover": {
      background: theme.palette.base.modal,
      color: theme.palette.base.contrast,
      boxShadow: "none",
    },
  });

  const customLoadingButtonColor = {
    background: theme.palette.btn.error.backgroundColor,
    color: theme.palette.btn.error.color,
    border: theme.palette.btn.error.border,
    boxShadow: "none",
  };
  
  const handleExec = () => {
    handleDelete(currentHelmTab);
    handleClose();
  };

  const handleClose = () => {
    props.close();
  };

  const makeDialogTitle = (mode: ECoordinateTransformMode): string => {
    switch (mode) {
      case ECoordinateTransformMode.INPUT:
        return t("DELETE_COORDINATE_POINTS");
      case ECoordinateTransformMode.TRANSFORM:
        return t("DELETE_CONTROL_POINTS");
      case ECoordinateTransformMode.VERIFICATION:
        return t("DELETE_VERIFICATION_POINTS");
      default:
      // return "Unknown Mode";
    }
  };

  const makeDialogContent = (mode: ECoordinateTransformMode): string => {
    switch (mode) {
      case ECoordinateTransformMode.INPUT:
        return t("WANT_DELETE_ALL_COORDINATE_POINTS");
      case ECoordinateTransformMode.TRANSFORM:
        return t("WANT_DELETE_ALL_CONTROL_POINTS");
      case ECoordinateTransformMode.VERIFICATION:
        return t("WANT_DELETE_ALL_VERIFICATION_POINTS");
      default:
      // return "Unknown Mode";
    }
  };

  return (
    <Dialog
      open={props.open}
      PaperProps={{
        style: {
          width: "583px",
          height: "214px",
          background: customModalColor.color,
          boxShadow: "none",
          textAlign: "center",
          border: "1px solid #44444F",
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: customDialogBackgroundColor.color,
          },
        },
      }}
    >
      <DialogTitle
        style={{
          color: customColor.color,
          textAlign: "left",
          fontSize: "18px",
        }}
      >
        {makeDialogTitle(currentHelmTab)}
        <Button
          style={customColor}
          className="x-btn"
          onClick={handleClose}
          sx={{
            float: "right",
            fontSize: "18px",
            margin: "0px",
            padding: "0px",
            position: "absolute",
            right: "0px",
          }}
        >
          ×
        </Button>
        <div className="border-comm" />
      </DialogTitle>
      <DialogContent>{makeDialogContent(currentHelmTab)}</DialogContent>
      <DialogActions>
        <CustomCanselButton
          className="re-btn-com re-btn1"
          onClick={handleClose}
        >
          {t("CANCEL")}
        </CustomCanselButton>
        <Button
          style={customLoadingButtonColor}
          className="re-btn-com re-btn2"
          onClick={handleExec}
        >
          {t("REMOVE")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAllPointsDialog;
